export default __webpack_public_path__ + "static/media/KZ.M.11.2338.a3ba6cf4.svg";